import { Component, Injector } from '@angular/core';
import { CoreService } from 'core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
  buttonColor: string = ""
  buttons: any[] = Array<any>()
  constructor(private injectorObj: Injector) {
    let dataset = this.injectorObj.get(CoreService).appDetails;
    this.buttonColor = dataset.web_app_primary_color;
    this.buttons = [

      { row: 0, IconName: 'store', DisplayName: "Store",handler: dataset.store_url , color: this.buttonColor },
      // { row: 0, IconName: 'id-card', DisplayName: "Join",handler: "", color: this.buttonColor},
      {
        row: 1, IconName: 'message-pen', handler: "https://jamnola.com/pages/frenchmen-feedback", DisplayName: 'Give Feedback', color: this.buttonColor
      },
      // { row: 1, IconName: 'circle-dollar-to-slot', DisplayName: 'Donate',handler: "", color: this.buttonColor }
  
    ]
    // this.buttons[0].handler = dataset.store_url;
    // this.buttons[1].handler = dataset.membership_url
    // this.buttons[2].handler = dataset.buy_tickets_url
    // this.buttons[3].handler = dataset.donation_url
  }
  
}
